import { useQuery } from 'react-query';
import { matchesService } from 'matches/services/matchesService';

export function useMatchesQuery() {
  return useQuery(['matchesService_getMatches'], () => matchesService.getMatches());
}
